import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loading } from "../nav/Loading";
import { UserContext } from "./UserProvider";
export var PrivateRoute = function (_a) {
    var children = _a.children;
    var location = useLocation();
    var _b = useContext(UserContext), user = _b.user, loading = _b.loading;
    if (loading) {
        return _jsx(Loading, {});
    }
    if (user === null) {
        return (_jsx(Navigate, { to: "/login", state: {
                from: "".concat(location.pathname).concat(location.search).concat(location.hash),
            }, replace: true }));
    }
    return children;
};
